import { DateTitle } from 'Shared/frontend/PosterTitle';
import { css, cx } from '@emotion/css';
import { fonts, poster} from 'Shared/frontend/SettingsProvider';


/* flexShrink because the poster is a flex item in the carousel and grid layouts, and its own
   'overflow:hidden' zeroes the automatic minimum size a flex item would otherwise get - without
   this the posters are squeezed well under their width and their right hand sides are cropped. */
const posterStyle = () => css(poster().root,{
	overflow: 'hidden',
	flexShrink: 0,
});

const dateStyle = () => css({
	fontFamily: fonts().heading,
	width: '100%',
	padding: '0.5em',
	textTransform: 'uppercase',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	// changed from set height to allow for 2nd line for Monthly dates, it will push uploaded poster down
	minHeight: 43.2,
	...poster().dateBar,
});

export const nameStyle = () => css(poster().name,{
	fontFamily: fonts().text,
});

export const eventTaglineStyle = () => css(poster().eventTagline,{
	fontFamily: fonts().text,
	lineHeight: '1.2em',
	textAlign: 'center',

});


export function Poster(P:{children})
{
	return (
		<div class={cx('capture',posterStyle())}>
			{ P.children }
		</div>
	);
}

export function DateWrap(P)
{
	const dateWrapStyle = css({
		width: 'inherit',
		height: 'inherit',
		display: 'flex !important',
		flexDirection: 'column',
		alignItems: 'stretch',
	});

	return (
		<div class={dateWrapStyle}>
			<div class={dateStyle()}>
				{P.times.customLabel ?? <DateTitle {...P.times}/> }
			</div>

			{ P.children }
		</div>
	);
}

export function maxTextLines(maxLines:number) 
{
	/* 
		In time should be able to use unprefixed line-clamp. 
		See: https://caniuse.com/?search=line-clamp for progress 
	*/
	const limitProperties = maxLines==1 ? { whiteSpace: 'nowrap' } : {
		display: '-webkit-box',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: `${maxLines}`
	};

	return {
		...limitProperties,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	};
}

